import { Configuration } from './configuration';
import { ApiProxyApi, PeAnApi, PublicDataApi } from './api';
import axios from 'axios';
class ApiEndpoints {
    constructor() {
        this.localBasePath = 'http://localhost/CVPnet%20Api/'.replace(/\/+$/, '');
        this.localBasePathProxy = 'https://localhost:7137/'.replace(/\/+$/, '');
        this.devBasePath = 'https://testapi.vereinverwalten.de'.replace(/\/+$/, '');
        this.devBasePathProxy = 'https://proxyapi.vereinverwalten.de'.replace(/\/+$/, ''); // TODO: Subdomain f�r TestProxyApi anlegen!
        this.prodBasePath = 'https://cvpnetappapi.vereinverwalten.de'.replace(/\/+$/, '""');
        this.prodBasePathProxy = 'https://proxyapi.vereinverwalten.de'.replace(/\/+$/, '""');
        this.basePath = process.env.VUE_APP_ENVIRONMENT == 'DEVELOPMENT' ? this.localBasePath : process.env.VUE_APP_ENVIRONMENT == 'PRODUCTION' ? this.prodBasePath : this.devBasePath;
        this.basePathProxy = process.env.VUE_APP_ENVIRONMENT == 'DEVELOPMENT' ? this.localBasePathProxy : process.env.VUE_APP_ENVIRONMENT == 'PRODUCTION' ? this.prodBasePathProxy : this.devBasePathProxy;
        this.configuration = new Configuration({ basePath: this.basePath });
        this.proxyConfiguration = new Configuration({ basePath: this.basePathProxy });
        this.createConfiguration();
        this.addInterceptors();
    }
    addInterceptors() {
        axios.interceptors.request.use(request => {
            request.headers['CvpService'] = `PeAn`;
            return request;
        });
    }
    createConfiguration() {
        const config = new Configuration({ basePath: this.basePath });
        config.baseOptions = {
            withCredentials: false // process.env.VUE_APP_ENVIRONMENT !== 'development'
        };
        const configProxy = new Configuration({ basePath: this.basePathProxy });
        configProxy.baseOptions = {
            withCredentials: false // process.env.VUE_APP_ENVIRONMENT !== 'development'
        };
        this.configuration = config;
        this.proxyConfiguration = configProxy;
    }
    get BasePath() {
        return this.configuration.basePath;
    }
    get ApiProxy() {
        return new ApiProxyApi(this.proxyConfiguration);
    }
    get PublicData() {
        return new PublicDataApi(this.configuration);
    }
    get PeAn() {
        return new PeAnApi(this.configuration);
    }
}
export const Api = new ApiEndpoints();
